"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
require('../swot/swot.component.css');
var angular = require("angular");
var inav_utils_service_1 = require("../../../components/utils/inav-utils.service");
var issue_list_1 = require("../../../components/utils/issue-list/issue-list");
var SwotComponent = /** @class */ (function () {
    function SwotComponent($rootScope, $scope, $timeout) {
        this.issueConfig = {};
        this.disableEdit = false;
        this.isOverflown = function (_a) {
            var clientHeight = _a.clientHeight, scrollHeight = _a.scrollHeight;
            return scrollHeight > clientHeight;
        };
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.options = { show: true, id: -1 };
        ctrl.$timeout = $timeout;
        ctrl.utilsService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.SWOT);
        ctrl.debounceValue = ctrl.utilsService.debounceDefault;
        ctrl.initListeners(ctrl);
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        $timeout();
    }
    SwotComponent.prototype.initListeners = function (ctrl) {
        ctrl.initBootstrapListeners(ctrl);
        ctrl.initDragListeners(ctrl);
        ctrl.initSwotListeners(ctrl);
    };
    SwotComponent.prototype.initBootstrapListeners = function (ctrl) {
        ctrl.$scope.$on('saveSWOT', function (event, args) {
            ctrl.selectedIssue = __assign({}, args.selectedIssue);
            ctrl.saveFromDialog();
        });
        ctrl.$scope.$on('command:SWOT', function (event, args) {
            ctrl.disableEdit = (args.node.permissions == 'r');
            ctrl.initComponent(event, args);
            ctrl.$scope.$emit('workbench:loading', { 'load': false });
        });
        ctrl.$scope.$on('CopiedFromAllStickies', function (event, args) {
            ctrl.copiedFromAllStickies = args.status;
        });
    };
    SwotComponent.prototype.initDragListeners = function () {
        var ctrl = this;
        ctrl.$scope.$on('DragStart', function (event, args) {
            // console.log(args.id);
            ctrl.draggableItemId = args.id;
        });
        ctrl.$scope.$on('DragOver', function (event, args) {
            var el = document.getElementById(ctrl.draggableItemId);
            el.style.backgroundColor = ctrl.utilsService.issueType[args.type].COLOR;
            el.style.opacity = '0.4';
            var divCollection = [].slice.call(args.container[0].children);
            var dragAfterElement = ctrl.utilsService.getDragElement(divCollection, args.event.clientY);
            if (dragAfterElement) {
                // To get the target index of draggable item to be placed
                divCollection.find(function (x, index) {
                    ctrl.dropIndex = index;
                    return x == dragAfterElement;
                });
            }
            args.container[0].insertBefore(el.parentElement, dragAfterElement);
        });
        ctrl.$scope.$on('DragEnd', function (event, args) {
            var dragEl = document.getElementById(ctrl.draggableItemId);
            if (dragEl) {
                dragEl.style.opacity = "1.0";
            }
        });
    };
    SwotComponent.prototype.initSwotListeners = function () {
        var ctrl = this;
        ['DropDefault', 'DropStrengths', 'DropWeaknesses', 'DropOpportunities', 'DropThreats'].forEach(function (dropZone) {
            ctrl.$scope.$on(dropZone, function (event, args) {
                ctrl.setIssueDetails(dropZone, args);
            });
        });
    };
    SwotComponent.prototype.setIssueDetails = function (dropZone, args) {
        var ctrl = this;
        var type = ctrl.utilsService.getTypeByDropZone(dropZone);
        // Assuming moving from feasibility:0 (drag location) to desirability:2 (drop location)
        // Remove from drag location but when drop it to some other location (Either other index, or other dropzone)
        var dragEl = document.getElementById(ctrl.draggableItemId);
        var dragElArray = ctrl.draggableItemId.split(":"); // [0]: type, [1]: index
        // When not dropped at same location i.e Same index and same zone
        if (!((dragElArray[0] == ctrl.utilsService.issueType[type].NAME) && (dragElArray[1] == ctrl.dropIndex))) {
            args.container[0].removeChild(dragEl.parentElement);
        }
        ctrl.issueDetails = ctrl.getDataAndRemove(args.swot, args.id);
        var previousType = ctrl.issueDetails.type;
        ctrl.issueDetails.type = ctrl.utilsService.issueType[type].NAME;
        ctrl.issueDetails.updatedAt = ctrl.utilsService.updatedAt();
        //Add sticky to targeted position instead of end.
        ctrl.utilsService.issueList[type].splice(ctrl.dropIndex, 0, ctrl.issueDetails);
        // Set the opacity and color of updated element which has taken draggable item id
        if (dragEl) {
            dragEl.style.opacity = "1.0";
            dragEl.style.backgroundColor = ctrl.utilsService.issueType[previousType.toUpperCase()].COLOR;
        }
        // Adjust height of zone (drag and drop both)
        ctrl.utilsService.issueList[type].forEach(function (el) {
            el.isHeightUpdated = false;
        });
        ctrl.utilsService.issueList[previousType.toUpperCase()].forEach(function (el) {
            el.isHeightUpdated = false;
        });
        ctrl.saveIssueData(ctrl.issueDetails._id, ctrl.issueDetails.type);
        ctrl.$scope.$apply();
    };
    SwotComponent.prototype.resetAllStickies = function () {
        var ctrl = this;
        ctrl.allStickies = [];
        ctrl.utilsService.issueList.DEFAULT = [];
    };
    SwotComponent.prototype.formatIssueData = function (item) {
        var ctrl = this;
        item.description = 'description' in item ? item.description : "";
        item.title = ctrl.utilsService.returnLimitedTitle(item);
        var impactToBeUsed = ctrl.isQualitative ? item.impact : item.calcImpact;
        // item.impact = impactToBeUsed;
        item.score = item.ignorance * impactToBeUsed;
        item.issueType = ctrl.utilsService.getDiscoveryGrid(item.ignorance, impactToBeUsed);
        item.color = ctrl.issueConfig[item.type];
        if (item.experimentData.length > 0) {
            item.experimentData = item.experimentData[0];
        }
        else {
            item.experimentData.defined = 0;
        }
        item.isSwot = item.type != this.utilsService.issueType.DEFAULT.NAME;
        item.isHeightUpdated = false;
        item.showFooter = false;
        return item;
    };
    SwotComponent.prototype.setStickyHeight = function (id, stickyIndex, node) {
        // console.log(id+' : '+stickyIndex+" : ");
        var ctrl = this;
        if (!node.isHeightUpdated) {
            ctrl.setFontSize(id, stickyIndex);
            node.isHeightUpdated = true;
        }
    };
    SwotComponent.prototype.setFontSize = function (id, stickyIndex) {
        var ctrl = this;
        var stickyID = id + stickyIndex;
        var element = document.getElementById(stickyID);
        if (element != null) {
            ctrl.updateStickyHeight(element);
        }
    };
    SwotComponent.prototype.updateStickyHeight = function (element) {
        element.style.height = "1px";
        element.style.height = (3 + element.scrollHeight) + "px"; // 3 px for padding so 5px for adjustments
        var targetParentBlock = element.parentElement.parentElement.parentElement.parentElement;
        if (targetParentBlock.classList.contains("block") || targetParentBlock.classList.contains("centered-sticky")) {
            targetParentBlock.style.height = "1px";
            targetParentBlock.style.height = (53 + element.scrollHeight) + "px";
        }
    };
    SwotComponent.prototype.onEditSticky = function (issueId, list) {
        var ctrl = this;
        for (var i = 0; i < list.length; i++) {
            if (issueId == list[i]._id) {
                ctrl.selectedIssue = angular.copy(list[i]);
                ctrl.theIndex = i;
                ctrl.theList = list;
                ctrl.selectedIssue.prevType = ctrl.selectedIssue.type;
                ctrl.$timeout(function () {
                    ctrl.$scope.$emit('issueModal', { 'modalData': ctrl.modalData, 'selectedIssue': ctrl.selectedIssue, 'node': ctrl.node,
                        'issueList': issue_list_1.IssueListEnum.SWOT, fteGlobal: ctrl.fteGlobal });
                    ctrl.$scope.$apply();
                }, 1000);
                break;
            }
        }
    };
    SwotComponent.prototype.onBlur = function (note) {
        note.isEditable = false;
    };
    SwotComponent.prototype.onStickyChange = function (key, stickyIndex, note) {
        var ctrl = this;
        ctrl.updateChangeDate(key, stickyIndex);
        ctrl.utilsService.setFontSize(note, key, stickyIndex);
        ctrl.saveIssueData(note._id, key);
    };
    SwotComponent.prototype.updateChangeDate = function (swot, id) {
        var ctrl = this;
        ctrl.utilsService.issueList[swot.toUpperCase()][id].updatedAt = ctrl.utilsService.updatedAt();
    };
    SwotComponent.prototype.addSticky = function () {
        var ctrl = this;
        var newGot = ctrl.utilsService.getNewSticky(ctrl.userName);
        ctrl.utilsService.issueList.DEFAULT.unshift(newGot);
        // Adjust height of zone
        ctrl.utilsService.issueList.DEFAULT.forEach(function (el) {
            el.isHeightUpdated = false;
        });
        ctrl.saveIssueData(newGot._id, 'default');
    };
    SwotComponent.prototype.deleteNode = function (issueId, list) {
        var ctrl = this;
        bootbox.dialog({
            message: "You are about to delete this issue. Are you sure?",
            title: "Confirm Deletion",
            buttons: {
                confirm: {
                    label: "Delete",
                    className: "btn-danger",
                    callback: function () {
                        ctrl.deleteSticky(issueId, list);
                    }
                },
                cancel: {
                    label: "Cancel",
                    className: "btn-primary"
                }
            }
        });
    };
    ;
    SwotComponent.prototype.deleteSticky = function (issueId, list) {
        var ctrl = this;
        for (var i = 0; i < list.length; i++) {
            if (issueId == list[i]._id) {
                list.splice(i, 1);
                break;
            }
        }
        // Adjust height of zone
        list.forEach(function (el) {
            el.isHeightUpdated = false;
        });
        ctrl.deleteIssueById(issueId);
    };
    SwotComponent.prototype.showIssueInfo = function (issueId) {
        var ctrl = this;
        bootbox.dialog({
            message: "Node Id: " + ctrl.node._id + " <br> Issue Id: " + issueId,
            title: "Issue Info",
            buttons: {
                cancel: {
                    label: "Cancel",
                    className: "btn-primary"
                }
            }
        });
    };
    SwotComponent.prototype.setHoveredSticky = function (show, id) {
        var ctrl = this;
        ctrl.options = { show: true, id: id };
    };
    SwotComponent.prototype.showIcons = function (id) {
        var ctrl = this;
        return ctrl.options.show == true && ctrl.options.id == id;
    };
    SwotComponent.prototype.removeIssueByIndex = function (array, index) {
        if (index > -1) {
            array.splice(index, 1);
        }
    };
    SwotComponent.prototype.getDataAndRemove = function (swot, id) {
        var ctrl = this;
        var data = {};
        switch (swot.toLowerCase()) {
            case ctrl.utilsService.issueType.DEFAULT.NAME:
                data = ctrl.utilsService.issueList.DEFAULT[id];
                ctrl.removeIssueByIndex(ctrl.utilsService.issueList.DEFAULT, id);
                break;
            case ctrl.utilsService.issueType.STRENGTHS.NAME:
                data = ctrl.utilsService.issueList.STRENGTHS[id];
                ctrl.removeIssueByIndex(ctrl.utilsService.issueList.STRENGTHS, id);
                break;
            case ctrl.utilsService.issueType.WEAKNESSES.NAME:
                data = ctrl.utilsService.issueList.WEAKNESSES[id];
                ctrl.removeIssueByIndex(ctrl.utilsService.issueList.WEAKNESSES, id);
                break;
            case ctrl.utilsService.issueType.OPPORTUNITIES.NAME:
                data = ctrl.utilsService.issueList.OPPORTUNITIES[id];
                ctrl.removeIssueByIndex(ctrl.utilsService.issueList.OPPORTUNITIES, id);
                break;
            case ctrl.utilsService.issueType.THREATS.NAME:
                data = ctrl.utilsService.issueList.THREATS[id];
                ctrl.removeIssueByIndex(ctrl.utilsService.issueList.THREATS, id);
                break;
        }
        return data;
    };
    SwotComponent.prototype.initComponent = function (event, args) {
        var ctrl = this;
        ctrl.title = args.actionMenuItem;
        ctrl.userName = args.userName;
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
        ctrl.fteGlobal = args.fte;
        ctrl.menu = [];
        ctrl.getSWOTData();
    };
    SwotComponent.prototype.getSWOTData = function () {
        var ctrl = this;
        ctrl.smartorg.getSWOTData(ctrl.node._id).then(function (res) {
            if (res) {
                ctrl.initSWOTData(res);
                ctrl.$timeout();
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    SwotComponent.prototype.saveFromDialog = function () {
        var ctrl = this;
        ctrl.theList[ctrl.theIndex] = __assign({}, ctrl.selectedIssue);
        ctrl.showMsg = true;
        ctrl.saveIssueData(ctrl.selectedIssue._id, ctrl.selectedIssue.prevType);
    };
    SwotComponent.prototype.saveIssueData = function (id, key) {
        var ctrl = this;
        // let selectedIssue = ctrl.issueDetails;
        // let impactToBeUsed = ctrl.isQualitative ? selectedIssue.impact : selectedIssue.calcImpact;
        // let issueToBeSaved = {
        //     '_id': selectedIssue._id,
        //     'name': selectedIssue.name,
        //     'ignorance': selectedIssue.ignorance,
        //     'impact': selectedIssue.impact,
        //     'calcImpact': selectedIssue.calcImpact,
        //     'score': selectedIssue.ignorance * impactToBeUsed,
        //     'type': selectedIssue.type,
        //     'impactMappingList': selectedIssue.impactMappingList,
        //     'updatedAt': selectedIssue.updatedAt,
        //     'isPotentialShowStopper': selectedIssue.isPotentialShowStopper,
        //     'abilityToLaunch': selectedIssue.abilityToLaunch,
        //     'inIterationPlan': selectedIssue.inIterationPlan,
        //     'startDate': selectedIssue.startDate,
        //     'endDate': selectedIssue.endDate,
        //     'experiments': selectedIssue.experiments
        // };
        var issueToBeSaved = ctrl.utilsService.issueList[key.toUpperCase()].find(function (x) { return x._id == id; });
        // issueToBeSaved.showFooter = false;
        ctrl.smartorg.saveInavIssueData(issueToBeSaved, ctrl.node['_id']).then(function (res) {
            if (res) {
                if (ctrl.showMsg) {
                    ctrl.showAlert('success', 'Deleted!', 'Details saved for issue "' +
                        (issueToBeSaved['title'] ? issueToBeSaved['title'] : issueToBeSaved['name']) + '"');
                    ctrl.getSWOTData();
                    ctrl.showMsg = false;
                }
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    SwotComponent.prototype.saveSWOT = function () {
        var ctrl = this;
        ctrl.utilsService.getValues();
        // if (!ctrl.duplicateExists()) {
        var swotData = {
            "default": ctrl.utilsService.issueList.DEFAULT,
            strengths: ctrl.utilsService.issueList.STRENGTHS,
            weaknesses: ctrl.utilsService.issueList.WEAKNESSES,
            opportunities: ctrl.utilsService.issueList.OPPORTUNITIES,
            threats: ctrl.utilsService.issueList.THREATS
        };
        ctrl.$timeout(function () {
            ctrl.smartorg.saveSWOTData(ctrl.node._id, swotData).then(function (ret) {
                if ('status' in ret && ret['status'] == 0) {
                    if (ctrl.showMsg) {
                        ctrl.showAlert('success', 'Success!', "Saved successfully.");
                        ctrl.getSWOTData();
                        ctrl.showMsg = false;
                    }
                    ctrl.$scope.$apply();
                }
                else {
                    // ctrl.showAlert('danger', 'Error!', ret.message);
                }
            })["catch"](function (err) {
                ctrl.showAlert('danger', 'Error!', err.message);
            });
        }, 500);
        // }
    };
    SwotComponent.prototype.deleteIssueById = function (issueId) {
        var ctrl = this;
        ctrl.smartorg.deleteInavIssueById(ctrl.node._id, issueId).then(function (res) {
            if (res) {
                ctrl.showAlert('success', 'Deleted!', 'Issue has been deleted');
                // ctrl.clearSelection();
                // ctrl.getCanvasData();
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    SwotComponent.prototype.initSWOTData = function (res) {
        var ctrl = this;
        ctrl.issueConfig = ctrl.utilsService.getIssueConfig(res['CanvasConfig']);
        ctrl.utilsService.issueList.DEFAULT = res['NColCanvasSwotData']['default'].map(function (x) { return ctrl.formatIssueData(x); });
        ctrl.utilsService.issueList.STRENGTHS = res['NColCanvasSwotData']['strengths'].map(function (x) { return ctrl.formatIssueData(x); });
        ;
        ctrl.utilsService.issueList.WEAKNESSES = res['NColCanvasSwotData']['weaknesses'].map(function (x) { return ctrl.formatIssueData(x); });
        ;
        ctrl.utilsService.issueList.OPPORTUNITIES = res['NColCanvasSwotData']['opportunities'].map(function (x) { return ctrl.formatIssueData(x); });
        ;
        ctrl.utilsService.issueList.THREATS = res['NColCanvasSwotData']['threats'].map(function (x) { return ctrl.formatIssueData(x); });
        ;
        ctrl.modalData = {
            distInputs: res['ColHeaders'],
            inputTypeLt: res['RadioOrCheckBox'],
            npvData: res['NPVSwing']
        };
    };
    return SwotComponent;
}());
exports.SwotComponent = SwotComponent;
function getDropDetails(ev) {
    ev.preventDefault();
    var data = ev.originalEvent.dataTransfer.getData('text/plain');
    var draggable = document.getElementById(data);
    var textarea = draggable.getElementsByTagName('textarea');
    var nameGot = textarea[0].value;
    var swot = data.split(":")[0];
    var id = parseInt(data.split(":")[1]);
    return { nameGot: nameGot, swot: swot, id: id };
}
angular.module('smartorg.r6.acts.swot', []).component('swot', {
    template: require('./swot.component.html'),
    controller: SwotComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
})
    .directive('noteSwotContent', function () {
    return {
        restrict: 'E',
        link: function (scope, element, attrs) {
            element.bind('click', function () {
                scope.contenteditable = true;
            });
        }
    };
})
    .directive('noteSwot', function ($document) {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template: '<div class="note"><div class="noteBody" ng-transclude></div></div>',
        link: function (scope, element, attr) {
            element.on('dragstart', function (ev) {
                scope.$emit('DragStart', { 'id': ev.target.id });
                ev.originalEvent.dataTransfer.setData('text/plain', ev.target.id);
                setTimeout(function () {
                    // ev.target.classList.add('hide');
                }, 0);
                if (ev.target.id.indexOf('sticky') !== -1) {
                    scope.$emit('CopiedFromAllStickies', { 'status': true });
                }
                else {
                    scope.$emit('CopiedFromAllStickies', { 'status': false });
                }
                scope.$apply();
            });
        }
    };
})
    .directive('dragDropAddStickiesSwot', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
                scope.$emit('DragOver', { 'type': 'DEFAULT', 'container': element, 'event': event });
            });
            element.on('dragend', function (ev) {
                scope.$emit('DragEnd', { 'id': ev.target.id });
                scope.$apply();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), nameGot = _a.nameGot, swot = _a.swot, id = _a.id;
                scope.$emit('DropDefault', { 'issue': nameGot, swot: swot, id: id, 'container': element });
            });
        }
    };
})
    .directive('dragDropStrength', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
                scope.$emit('DragOver', { 'type': 'STRENGTHS', 'container': element, 'event': event });
            });
            element.on('dragend', function (ev) {
                scope.$emit('DragEnd', { 'id': ev.target.id });
                scope.$apply();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), nameGot = _a.nameGot, swot = _a.swot, id = _a.id;
                scope.$emit('DropStrengths', { 'issue': nameGot, swot: swot, id: id, 'container': element });
            });
        }
    };
})
    .directive('dragDropWeakness', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
                scope.$emit('DragOver', { 'type': 'WEAKNESSES', 'container': element, 'event': event });
            });
            element.on('dragend', function (ev) {
                scope.$emit('DragEnd', { 'id': ev.target.id });
                scope.$apply();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), nameGot = _a.nameGot, swot = _a.swot, id = _a.id;
                scope.$emit('DropWeaknesses', { 'issue': nameGot, swot: swot, id: id, 'container': element });
            });
        }
    };
})
    .directive('dragDropOpportunity', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
                scope.$emit('DragOver', { 'type': 'OPPORTUNITIES', 'container': element, 'event': event });
            });
            element.on('dragend', function (ev) {
                scope.$emit('DragEnd', { 'id': ev.target.id });
                scope.$apply();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), nameGot = _a.nameGot, swot = _a.swot, id = _a.id;
                scope.$emit('DropOpportunities', { 'issue': nameGot, swot: swot, id: id, 'container': element });
            });
        }
    };
})
    .directive('dragDropThreat', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
                scope.$emit('DragOver', { 'type': 'THREATS', 'container': element, 'event': event });
            });
            element.on('dragend', function (ev) {
                scope.$emit('DragEnd', { 'id': ev.target.id });
                scope.$apply();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), nameGot = _a.nameGot, swot = _a.swot, id = _a.id;
                scope.$emit('DropThreats', { 'issue': nameGot, swot: swot, id: id, 'container': element });
            });
        }
    };
});
module.exports = 'smartorg.r6.acts.swot';
//# sourceMappingURL=swot.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/swot/swot.component.js